import { createContext, Dispatch, SetStateAction, useCallback, useContext, useMemo, useState } from 'react';
import { LlmAction } from '../types';

export type LlmChunkWrapper = {
  node: HTMLDivElement;
  id: string | null;
  actions: LlmAction[];
};

export type ActionsContextState = {
  wrapper: LlmChunkWrapper | null;
  setWrapperNode: (wrapper: HTMLDivElement) => void;
  setWrapper: Dispatch<SetStateAction<LlmChunkWrapper | null>>;
};

export const ActionsContext = createContext<ActionsContextState>({
  wrapper: null,
  setWrapperNode: (wrapper) => {
    console.log('setWrapperNode not set', wrapper.id);
  },
  setWrapper: () => {
    console.log('setWrapper not set');
  },
});

type ActionsProviderProps = React.PropsWithChildren;

function ActionsProvider({ children }: ActionsProviderProps) {
  const [wrapper, setWrapper] = useState<LlmChunkWrapper | null>(null);

  const setWrapperNode = useCallback((wrapper: HTMLDivElement) => {
    const parseActions = (wrapper: HTMLDivElement): [] => {
      try {
        const dataActions = wrapper.getAttribute('data-actions');
        const actions = dataActions ? JSON.parse(dataActions) : [];
        // console.log('setWrapperNode.parseActions', actions);
        return actions;
      } catch (error) {
        console.log('setWrapperNode.parseActions.error', error);
        return [];
      }
    };
    const actions = parseActions(wrapper);
    if (actions.length > 0) {
      const newWrapper = {
        node: wrapper,
        id: wrapper.id,
        actions,
      };
      // console.log('setWrapper', newWrapper);
      setWrapper(newWrapper);
    }
  }, [setWrapper]);

  const value = useMemo(() => {
    return {
      wrapper,
      setWrapperNode,
      setWrapper,
    };
  }, [wrapper, setWrapperNode, setWrapper]);

  return (
    <ActionsContext.Provider value={value}>
      {children}
    </ActionsContext.Provider>
  );
}

function useActions() {
  const wrapper = useContext(ActionsContext);
  return wrapper;
}

export { ActionsProvider, useActions };

